import React, { useEffect, useState, Suspense } from 'react';

const VideoPlayerNew = React.lazy(() => import(/* webpackChunkName: "VideoPlayer" */ './VideoPlayer'));
import StyledVideoPlayerLazy from './VideoPlayerLazy.styles';
import NoJavascriptMessage from './NoJavascriptMessage/NoJavascriptMessage';
import { VideoPlayerProps } from './typings/VideoPlayerProps';

export default function VideoPlayerLazy(props: VideoPlayerProps) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return (
            <StyledVideoPlayerLazy className={props.className}>
                <noscript>
                    <NoJavascriptMessage />
                </noscript>
            </StyledVideoPlayerLazy>
        );
    }

    return (
        <Suspense fallback={<StyledVideoPlayerLazy className={props.className} />}>
            <VideoPlayerNew {...props} className={props.className} />
        </Suspense>
    );
}
